import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const IT_NUM = /^-?\d{1,3}(\.\d{3})*(,\d+)?\s*€?$/;

function cellText(cell) {
  const clone = cell.cloneNode(true);
  const origs = cell.querySelectorAll("input,select,textarea");
  const clones = clone.querySelectorAll("input,select,textarea");
  clones.forEach((el, i) => {
    const o = origs[i];
    let v = "";
    if (o) {
      if (o.type === "checkbox") v = o.checked ? "X" : "";
      else if (o.tagName === "SELECT") v = o.selectedOptions[0]?.textContent || o.value || "";
      else v = o.value || "";
    }
    el.replaceWith(document.createTextNode(v));
  });
  clone.querySelectorAll("button").forEach((b) => b.remove());
  return clone.textContent.replace(/\s+/g, " ").trim();
}

export function extractTable(table) {
  const headRow = table.tHead?.rows?.[0];
  const head = [];
  if (headRow) {
    for (const th of headRow.cells) {
      head.push(cellText(th));
      for (let i = 1; i < (th.colSpan || 1); i++) head.push("");
    }
  }
  const trs = [];
  for (const tb of table.tBodies) for (const tr of tb.rows) trs.push(tr);
  const rowCb = (tr) => {
    const cb = tr.cells[0]?.querySelector('input[type="checkbox"]');
    return cb && !cb.disabled ? cb : null;
  };
  const onlySelected = !!table.tHead?.querySelector('input[type="checkbox"]') && trs.some((tr) => rowCb(tr)?.checked);
  const body = [];
  for (const tr of trs) {
    if (tr.offsetParent === null) continue;
    if (onlySelected && !rowCb(tr)?.checked) continue;
    const row = [];
    for (const td of tr.cells) {
      row.push(cellText(td));
      for (let i = 1; i < (td.colSpan || 1); i++) row.push("");
    }
    body.push(row);
  }
  if (onlySelected) {
    head.shift();
    body.forEach((r) => r.shift());
  }
  return { head, body };
}

export function tableTitle(table) {
  const panel = table.closest(".panel, .modal, .card, section");
  const h = panel?.querySelector("h1,h2,h3,h4")?.textContent
    || document.querySelector("main h1")?.textContent
    || document.title || "Tabella";
  return h.replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}]/gu, "").replace(/\s+/g, " ").trim() || "Tabella";
}

function fileBase(title) {
  const d = new Date().toISOString().slice(0, 10);
  return `${title.toLowerCase().replace(/[^a-z0-9àèéìòù]+/gi, "-").replace(/^-+|-+$/g, "").slice(0, 60) || "tabella"}_${d}`;
}

export function exportExcel(table) {
  const { head, body } = extractTable(table);
  const title = tableTitle(table);
  const parsed = body.map((row) => row.map((v) => {
    if (v && IT_NUM.test(v)) {
      const n = parseFloat(v.replace(/€/g, "").trim().replace(/\./g, "").replace(",", "."));
      if (!Number.isNaN(n)) return n;
    }
    return v;
  }));
  const aoa = head.length ? [head, ...parsed] : parsed;
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws["!cols"] = (head.length ? head : parsed[0] || []).map((_, c) => ({
    wch: Math.min(40, Math.max(8, ...aoa.map((r) => String(r[c] ?? "").length))),
  }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Dati");
  XLSX.writeFile(wb, `${fileBase(title)}.xlsx`);
}

export function exportPdf(table) {
  const { head, body } = extractTable(table);
  const title = tableTitle(table);
  const cols = head.length || body[0]?.length || 1;
  const doc = new jsPDF({ orientation: cols > 6 ? "landscape" : "portrait", unit: "pt", format: "a4" });
  doc.setFontSize(13);
  doc.text(title, 40, 36);
  doc.setFontSize(9);
  doc.setTextColor(120);
  doc.text(`Esportato il ${new Date().toLocaleDateString("it-IT")} — CRM Silvia Casali`, 40, 52);
  autoTable(doc, {
    head: head.length ? [head] : undefined,
    body,
    startY: 64,
    margin: { left: 24, right: 24 },
    styles: { fontSize: cols > 14 ? 5.5 : cols > 9 ? 6.5 : 8, cellPadding: 2.5, overflow: "linebreak" },
    headStyles: { fillColor: [30, 46, 84], textColor: 255, fontSize: cols > 14 ? 5.5 : cols > 9 ? 6.5 : 8 },
    alternateRowStyles: { fillColor: [243, 246, 252] },
  });
  doc.save(`${fileBase(title)}.pdf`);
}
